<template>
  <div>
    <RightTitle title="基本资料"></RightTitle>
    <!-- 表单 -->
    <div class="uar_form">
      <el-form ref="form" label-width="80px" size="medium" style="width:400px;">
        <el-form-item label="ID">
          <el-input v-model="person.id" clearable readonly></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="person.username" clearable readonly></el-input>
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="person.nick" clearable readonly></el-input>
        </el-form-item>
        <el-form-item label="可用积分">
          <el-input v-model="person.integral" clearable readonly></el-input>
        </el-form-item>
        <!-- <el-form-item label="等级">
          <el-input v-model="person.levelName" clearable readonly></el-input>
        </el-form-item> -->
        <el-form-item label="注册时间">
          <el-input v-model="person.regTime" clearable readonly></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="person.email" clearable readonly></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="person.phone" clearable readonly></el-input>
        </el-form-item>
        <el-form-item label="QQ">
          <el-input v-model="person.qq" clearable readonly></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// 记载组件
import RightTitle from "../../../components/RightTitle";
// 加载api
import { getUserInfo } from "../../../api/user";
export default {
  name: "person_index",
  components: {
    RightTitle
  },
  beforeRouteEnter(to, from, next) {
    getUserInfo().then(res => {
      next(vm => {
        vm.person.id = res.data.userID;
        vm.person.username = res.data.username;
        vm.person.nick = res.data.nick;
        vm.person.integral = res.data.integral;
        vm.person.levelName =
          res.data.levelIntegral + " 【" + res.data.levelName + "】";
        vm.person.regTime = res.data.regTime;
        vm.person.email = res.data.email;
        vm.person.phone = res.data.phone;
        vm.person.qq = res.data.qq;
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    getUserInfo().then(res => {
      this.person.id = res.data.userID;
      this.person.username = res.data.username;
      this.person.nick = res.data.nick;
      this.person.integral = res.data.integral;
      this.person.levelName =
        res.data.levelIntegral + " 【" + res.data.levelName + "】";
      this.person.regTime = res.data.regTime;
      this.person.email = res.data.email;
      this.person.phone = res.data.phone;
      this.person.qq = res.data.qq;
      next();
    });
  },
  data() {
    return {
      person: {
        id: "",
        username: "",
        nick: "",
        integral: 0,
        levelName: "",
        regTime: "",
        email: "",
        phone: "",
        qq: ""
      }
    };
  }
};
</script>

<style scoped>
</style>